import { useEffect, useState } from "react";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import { Header } from "@/components/site/Header";
import { SaveBanner } from "@/components/site/SaveBanner";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Problem } from "@/components/site/Problem";
import { InstallSequence } from "@/components/site/InstallSequence";
import { Mounts } from "@/components/site/Mounts";
import { PhotoSlots } from "@/components/site/PhotoSlots";
import { Compatibility } from "@/components/site/Compatibility";
import { Specs } from "@/components/site/Specs";
import { Calculator } from "@/components/site/Calculator";
import { QuoteForm } from "@/components/site/QuoteForm";
import { FAQ } from "@/components/site/FAQ";
import { Safety } from "@/components/site/Safety";
import { ClosingCTA } from "@/components/site/ClosingCTA";
import { Downloads } from "@/components/site/Downloads";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  const [estimate, setEstimate] = useState("");

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ autoRaf: true, lerp: 0.12 });
    setLenis(lenis);
    return () => {
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <SaveBanner />
        <Hero />
        <Marquee />
        <Problem />
        <InstallSequence />
        <Mounts />
        <PhotoSlots />
        <Compatibility />
        <Specs />
        <Calculator onSendEstimate={setEstimate} />
        <QuoteForm estimate={estimate} />
        <FAQ />
        <Safety />
        <ClosingCTA />
        <Downloads />
      </main>
      <Footer />
    </>
  );
}
